import React from 'react';
import perifaAppIcon from '../assets/perifa-pro-app-icon.png';

export function PublicLandingPage({ onAdminAccess }) {
  return (
    <main className="public-shell">
      <section className="public-hero">
        <div className="public-hero__content">
          <span className="eyebrow">Perifa Pro</span>
          <h1>Campeonato, comunidade e vitrine esportiva em uma plataforma só.</h1>
          <p>
            Organize times, jogadores, tabela, escalação, ranking, loja, transmissão e comunicação
            com estrutura pronta para campeonatos de bairro, escolinhas, ligas e projetos esportivos.
          </p>
          <div className="public-actions">
            <button className="primary-button" type="button" onClick={onAdminAccess}>
              Acessar painel
            </button>
            <a className="ghost-button public-link" href="#lgpd">
              Ver LGPD e termos
            </a>
          </div>
        </div>
        <div className="public-hero__badge" aria-label="Perifa Pro app">
          <img className="public-hero__icon" src={perifaAppIcon} alt="Perifa Pro app" />
          <span>App e painel integrados</span>
        </div>
      </section>

      <section className="public-grid">
        <article className="public-card">
          <strong>Gestão completa</strong>
          <p>Cadastre campeonatos, times, jogadores, campos, jogos e arbitragem com auditoria.</p>
        </article>
        <article className="public-card">
          <strong>Experiência mobile</strong>
          <p>App para acompanhar jogos, ranking, perfis, loja, chat e central da partida.</p>
        </article>
        <article className="public-card">
          <strong>Imagem profissional</strong>
          <p>Upload de fotos dos atletas para escalação, perfil, ranking e destaques do campeonato.</p>
        </article>
        <article className="public-card">
          <strong>Operação comercial</strong>
          <p>Base preparada para marketplace, pedidos, patrocínios, transmissão e expansão por tenant.</p>
        </article>
      </section>

      <section className="public-section" id="lgpd">
        <span className="eyebrow">LGPD</span>
        <h2>Privacidade, consentimento e remoção de imagem</h2>
        <p>
          O uso de foto, documentos e dados de saúde exige consentimento do atleta ou responsável.
          O painel registra consentimento de imagem no cadastro do jogador e mantém trilha de auditoria
          para alterações administrativas.
        </p>
        <div className="public-actions">
          <a className="inline-button public-link" href="/privacy.html" target="_blank" rel="noreferrer">
            Política de privacidade
          </a>
          <a className="inline-button public-link" href="/terms.html" target="_blank" rel="noreferrer">
            Termos de uso
          </a>
        </div>
      </section>
    </main>
  );
}
